export default __webpack_public_path__ + "static/media/level-9-bg.cdc3ed57.png";